import { Category, ICategoryArgs } from "../category/category.model";

export interface IJobTypeArgs extends ICategoryArgs {

}

export class JobType extends Category {

    constructor(data?: IJobTypeArgs) {
        super(data);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/job-type/job-type.model.ts